import _ from "lodash";
import React, {
  createContext,
  memo,
  useCallback,
  useContext,
  useMemo,
  useReducer,
} from "react";
import { DEFAULT_FILTERS } from "../modules/stringConstants";
import { FILTER_TYPES } from "PlannerElementDataSet/modules/PlannerElementDataSetConstants";
import { getCurrentFiltersFromFilterKeys } from "../modules/utils";

const { SEARCH } = FILTER_TYPES;
const RESET_FILTERS = "RESET_FILTERS";
const APPLY_FILTERS = "APPLY_FILTERS";

const reducer = (state, action) => {
  switch (action.type) {
    case SEARCH:
      return {
        ...state,
        [SEARCH]: action.payload,
      };

    case APPLY_FILTERS:
      return {
        ...state,
        ...(action.payload || {}),
      };

    case RESET_FILTERS:
      return DEFAULT_FILTERS;

    default:
      return state;
  }
};

const FilterContext = createContext();

const FilterProvider = memo(({ children, initialFilters = {} }) => {
  const mergedInitialFilters = _.merge({}, DEFAULT_FILTERS, initialFilters);

  const [state, dispatch] = useReducer(reducer, mergedInitialFilters);

  const filters = useMemo(
    () => getCurrentFiltersFromFilterKeys({ filters: state }),
    [state]
  );

  const handleFilterUpdate = useCallback(
    (type, value) => dispatch({ type, payload: value }),
    []
  );

  const handleApplyFilters = useCallback(
    value => handleFilterUpdate(APPLY_FILTERS, value),
    [handleFilterUpdate]
  );

  const resetFilters = useCallback(() => {
    dispatch({ type: RESET_FILTERS });
  }, []);

  const isDefaultFiltersApplied = useMemo(
    () => _.isEqual(state, DEFAULT_FILTERS),
    [state]
  );

  return (
    <FilterContext.Provider
      value={{
        filters,
        state,
        handleFilterUpdate,
        isDefaultFiltersApplied,
        resetFilters,
        handleApplyFilters,
        defaultFilters: DEFAULT_FILTERS,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
});

FilterProvider.displayName = "FilterProvider";

const useFilters = () => {
  return useContext(FilterContext);
};

export { FilterProvider, useFilters };
